import { cn } from '../../lib/utils';
import { TooltipIconButton } from './tooltip-icon-button';

function tableActionsColumnClass({
  minWidth = 'min-w-[5.5rem]',
  className,
} = {}) {
  return cn(minWidth, 'whitespace-nowrap text-right align-middle', className);
}

function TableActions({ children, className, stopPropagation = false }) {
  return (
    <div
      className={cn('flex items-center justify-end gap-0.5', className)}
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
    >
      {children}
    </div>
  );
}

function TableActionButton({ variant = 'outline', className, iconClassName = 'h-3.5 w-3.5', ...props }) {
  return (
    <TooltipIconButton
      variant={variant}
      size="icon"
      className={cn('h-8 w-8', className)}
      iconClassName={iconClassName}
      {...props}
    />
  );
}

export {
  TableActions,
  TableActionButton,
  tableActionsColumnClass,
};
